import REDUX_ACTION from 'modules/redux/constants/action'

/**
 * Removes the changes made to the instance.
 * @param  {string} path
 * @returns {Function}
 */
function discardLegacyReduxAction (path) {
  return {
    type: REDUX_ACTION.DISCARD,
    payload: {
      path
    }
  }
}

export {
  discardLegacyReduxAction
}
